import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
  HttpHeaders,
} from "@angular/common/http";
import { Location, isPlatformBrowser } from "@angular/common";
import { Injectable, OnInit } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ConfigService } from "../../config/config.service";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  domain: string = "";
  url: string = environment.serverDomain;
  
  constructor(
    public http: HttpClient,
    public location: Location,
    public config: ConfigService
  ) {
    console.log("getState: ", location.getState());
    console.log("path: ", location.path());
    console.log("get url: ", window.location.href);
    console.log("isPlatformBrowser: ", isPlatformBrowser);
    this.domain = this.getDomain(window.location.href);
    //this.url = "http://"+this.domain+":8080";
  }

  getDomain(uri): string {
    return uri
      .replace("http://", "")
      .replace("https://", "")
      .split(/[/?#]/)[0]
      .split(/[/:]/)[0];
  }

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }

    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    return this.http
      .get(this.url + "/" + endpoint, reqOpts)
      .pipe(catchError(this.config.handleError));
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    let url = this.url + "/" + endpoint;
    console.log("url  : ", url);
    
    const tokenData = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : '';
    const token = tokenData ? tokenData.accessToken : '';
    
    let headers = new HttpHeaders();
    
    // 토큰이 있을 때만 Authorization 헤더 추가
    if (token) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }

    const options = reqOpts ? { ...reqOpts, headers: headers } : { headers: headers };

    if (body instanceof FormData) {
      headers = headers.append('Content-Type', 'multipart/form-data');
      return this.http
        .post<any>(url, body, options)
        .pipe(catchError(this.config.handleError));
    } else {
      headers = headers.append('Content-Type', 'application/json');
      return this.http
        .post<any>(url, body, { ...options, headers })
        .pipe(catchError(this.config.handleError));
    }
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + "/" + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + "/" + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + "/" + endpoint, body, reqOpts);
  }
}
